import { NgModule } from '@angular/core';
import { LibCloseIconComponent } from './lib-close-icon.component';

@NgModule({
  declarations: [LibCloseIconComponent],
  imports: [],
  exports: [LibCloseIconComponent],
})
export class LibCloseIconModule {}
